/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MisconfigurationViolationsTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("MisconfigurationViolationsTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return MisconfigurationViolationsTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<MisconfigurationViolationsTrendWidgetConfiguration>): MisconfigurationViolationsTrendWidgetConfiguration {
        let obj = Object.assign(new MisconfigurationViolationsTrendWidgetConfiguration(), model);
        MisconfigurationViolationsTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MisconfigurationViolationsTrendWidgetConfiguration>): MisconfigurationViolationsTrendWidgetConfiguration {
        if (!model) return null;
        return MisconfigurationViolationsTrendWidgetConfiguration.newInstance(<MisconfigurationViolationsTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MisconfigurationViolationsTrendWidgetConfiguration) {
        if (!obj) return;

        models.MisconfigurationViolationsTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MisconfigurationViolationsTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MisconfigurationViolationsTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
